
<div :class="errorClasses">
  <slot />
  <p v-for="(error, i) in errors" :key="i" class="error-text">{{error.message}}</p>
</div>
